(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["logo"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const logo = document.querySelector('.parallax-logo');
  if (!logo) return;

  const maxFadeDistance = 500; // scroll distance before fully faded
  const parallaxFactor = 0.25; // slower parallax movement

  // cubic easing function (easeOutCubic)
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  const updateLogo = () => {
    const scrollTop = window.scrollY;
    const translateY = scrollTop * parallaxFactor;

    let t = scrollTop / maxFadeDistance;
    if (t > 1) t = 1;
    const opacity = 1 - easeOutCubic(t);

    logo.style.transform = `translateY(${translateY}px)`;
    logo.style.opacity = opacity;
  };

  window.addEventListener('scroll', updateLogo);
  window.addEventListener('resize', updateLogo);
  updateLogo();
});
  } catch(e) { console.error(e); }
})();

})();
